import axios from "../../../axiosConfig";
import {
  normalizeNetworkReportFactors,
  normalizeNetworkReportFactorMatrix,
  normalizeNetworkReportOrganizations,
  normalizeNetworkReportSummary,
} from "./networkReportFormatters";

const networkReportPath = (networkId, section) =>
  `/networks/${networkId}/reports/${section}`;

export const getNetworkReportSummary = async (networkId) => {
  const response = await axios.get(networkReportPath(networkId, "summary"));
  return normalizeNetworkReportSummary(response?.data || {});
};

export const getNetworkReportOrganizations = async (networkId) => {
  const response = await axios.get(networkReportPath(networkId, "organizations"));
  return normalizeNetworkReportOrganizations(response?.data || {});
};

export const getNetworkReportFactors = async (networkId) => {
  const response = await axios.get(networkReportPath(networkId, "factors"));
  return normalizeNetworkReportFactors(response?.data || {});
};

export const getNetworkReportFactorMatrix = async (networkId) => {
  const response = await axios.get(networkReportPath(networkId, "factor_matrix"));
  return normalizeNetworkReportFactorMatrix(response?.data || {});
};
